import React, {Component} from 'react';

export class CheckboxList extends Component {
    static displayName = CheckboxList.name;

    constructor(props) {
        super(props);
        this.state = {
            items: props.items,
            reportChange: props.onChange,
            selection: props.items.filter(i => i.checked).map(i => i.id)
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const newSelection = [...this.state.selection];
        if (event.target.checked) {
            newSelection.push(event.target.value);
        } else {
            newSelection.splice(this.state.selection.indexOf(event.target.value), 1);
        }

        if (this.state.reportChange) this.state.reportChange({selection: newSelection});
        this.setState({selection: newSelection});
    }

    render() {
        return (
            <div onChange={this.handleChange}>
                {this.state.items.map(item =>
                    <div key={item.id}>
                        <input type="checkbox" value={item.id} name="option" defaultChecked={item.checked}/>
                        <label htmlFor={item.id}>
                            {item.text}
                        </label>
                    </div>
                )}
            </div>
        );
    }
}
